import '@styles/common.less';
import '@styles/layout.less';
import './product.less';
import '@common';

import LazyLoad from 'vanilla-lazyload';

document.addEventListener('DOMContentLoaded', () => {
  new LazyLoad({
    elements_selector: '.lazy',
    threshold: 300,
  });
});
